//Module Keys
let locales = {};

//Merge Views
import mainView from 'Modules/behavior/views/main/lan/es';
import reportView from 'Modules/behavior/views/report/lan/es';
import reportFilterView from 'Modules/behavior/views/report/modals/filter/lan/es';
import reportExportView from 'Modules/behavior/views/report/modals/export/lan/es';

locales = {
    ...locales,
    ...mainView,
    ...reportView,
    ...reportFilterView,
    ...reportExportView,
};

export default locales;
